<div class="doc-preview-wrapper">
  @if (isLoading) {
    <div class="loading-overlay">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <!-- <p class="mt-2">Loading document...</p> -->
    </div>
  }

  @if (error && !isLoading) {
    <div class="alert alert-warning m-3" role="alert">
      <i class="bi bi-exclamation-triangle me-2"></i>
      {{ error }}
    </div>
  }

  @if (pdfDisplayUrl(); as pdfUrl) {
    <lib-pdf-viewer class="doc-preview-pdf" [src]="pdfUrl" height="100%"></lib-pdf-viewer>
  }

  <div #docxContainer class="docx-container" [class.d-none]="pdfDisplayUrl() !== null || isLoading"></div>
</div>
